import { render, staticRenderFns } from "./StudentsNumberModal.vue?vue&type=template&id=6f2c566a&scoped=true"
import script from "./StudentsNumberModal.vue?vue&type=script&lang=js"
export * from "./StudentsNumberModal.vue?vue&type=script&lang=js"
import style0 from "./StudentsNumberModal.vue?vue&type=style&index=0&id=6f2c566a&prod&lang=stylus&scoped=true"
import style1 from "./StudentsNumberModal.vue?vue&type=style&index=1&id=6f2c566a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2c566a",
  null
  
)

export default component.exports